import React from 'react'

import PortalModal from './PortalModal';
import Border from '../Border';
import Collapsible from 'react-collapsible';
import Dropdown from '../Dropdown';
import LinkSelect from "../LinkSelect";
import General from "../../utils/General";

export default class ProductSettingsModal extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      show: props.show,
      data: props.website.extra?.product_page_settings || {
        checkout_url: "",
        color_picker_style: "square",
        variant1_style: "btn_horizontal",
        variant2_style: "btn_horizontal",
        variant3_style: "btn_horizontal",
        product_page_count: 18,
        column_no: 3
      },
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _renderColorType(){
    let { data } = this.state
    let OPTIONS = [
      {
        value: "dropdown",
        label: "Dropdown Menu"
      },
      {
        value: "square",
        label: "Square Swatches"
      },
      {
        value: "circular",
        label: "Circular Swatches"
      },
      {
        value: "square_titles",
        label: "Square Swatches With Titles"
      },
      {
        value: "circular_titles",
        label: "Circular Swatches With Titles"
      },
      {
        value: "tiles",
        label: "Tiles"
      },
    ]
    return (
      <Border>
        <Collapsible
          trigger="Color Swatches"
        >
          <br/>
          <span>What style of color swatches would you like</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value == data.color_picker_style
            )}
            onChange={option => {
              data.color_picker_style = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
        </Collapsible>
      </Border>
    )
  }

  _renderVariantType(value){
    let { data } = this.state

    let key = `variant${value}_style`

    let OPTIONS = [
      {
        value: "dropdown",
        label: "Dropdown Menu"
      },
      {
        value: "btn_horizontal",
        label: "Button Horizontal"
      },
      {
        value: "btn_vertical",
        label: "Button Vertical"
      }
    ]
    return (
      <Border>
        <Collapsible
          trigger={`Variant ${value} Type`}
        >
          <br/>
          <span>What style of variant {value} would you like</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value == data[key]
            )}
            onChange={option => {
              data[key] = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
        </Collapsible>
      </Border>
    )
  }

  _checkoutPage() {
    let { data } = this.state

    return (
      <Border>
        <Collapsible
          trigger={`Checkout Page`}
        >
          <br/>
          <span>Link your checkout page</span>
          <LinkSelect
            type={"shop"}
            checkoutOnly={true}
            url={data.checkout_url}
            onUpdated={(url) => {
              data.checkout_url = url
              this.props.onUpdated(data)
            }}
          />
        </Collapsible>
      </Border>
    )
  }

  _checkoutType() {
    let { data } = this.state

    let OPTIONS = [
      {
        value: "instant",
        label: "Instant Checkout"
      },
      {
        value: "cart",
        label: "Cart Based Checkout"
      }
    ]
    return (
      <Border>
        <Collapsible
          trigger={`Checkout Experience`}
        >
          <br/>
          <span>What checkout experience would you prefer</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value === this.props.website.checkout_type
            )}
            onChange={option => {
              this.props.onCheckoutTypeUpdated(option.value)
            }}
            placeholder="Select An Option"
          />
        </Collapsible>
      </Border>
    )
  }

  _productsPerPage() {
    let { data } = this.state

    let OPTIONS = [
      {
        value: 6,
        label: "6 Products"
      },
      {
        value: 12,
        label: "12 Products"
      },
      {
        value: 18,
        label: "18 Products"
      },
      {
        value: 24,
        label: "24 Products"
      }
    ]

    let productPageCount = data.product_page_count || 18

    return (
      <Border>
        <Collapsible
          trigger={`# of Products Per Page`}
        >
          <br/>
          <span>The number of products to display</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value === productPageCount
            )}
            onChange={option => {
              data.product_page_count = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
        </Collapsible>
      </Border>
    )
  }

  _noOfColumns() {
    let { data } = this.state

    let OPTIONS = [
      {
        value: 2,
        label: "2 Columns"
      },
      {
        value: 3,
        label: "3 Columns"
      },
      {
        value: 4,
        label: "4 Columns"
      }
    ]

    let columnNo = data.columns_no || 3

    return (
      <Border>
        <Collapsible
          trigger={`# of Columns`}
        >
          <br/>
          <span>The number of columns to display</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value === columnNo
            )}
            onChange={option => {
              data.column_no = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
        </Collapsible>
      </Border>
    )
  }

  render() {
    let {
      show,
    } = this.state

    const productPage = window.location.pathname.includes("/product")

    const title = productPage ? "product" : "collection"

     return (
      <PortalModal
        show={show}
        loadSideMenuFromLeft="true"
        onHide={() => this.props.onHide()}
      >
        <h2 className="mb-0">
          {General.toTitleCase(title)} Page Settings
        </h2>
        <label className="mb-5">Adjust your {title} page core style</label>

        {
          productPage &&
          <>
            {this._checkoutType()}

            {this._checkoutPage()}

            {this._renderColorType()}

            {this._renderVariantType(1)}

            {this._renderVariantType(2)}

            {this._renderVariantType(3)}
          </>
        }

        {
          !productPage &&
          <>
            {this._checkoutType()}

            {this._checkoutPage()}

            {this._productsPerPage()}

            {this._noOfColumns()}
          </>
        }


      </PortalModal>
    )
  }
}
